export const SORT_OPTIONS = [
  { value: "default", label: "Recommended" },
  { value: "newest", label: "New Brands" },
  { value: "trending", label: "Trending" },
  { value: "popularity", label: "Popular" },
] as const;

export const REGIONS = [
  { code: "EUROPE", name: "Europe", flag: "🇪🇺" },
  { code: "NORTH_AMERICA", name: "North America", flag: "🌎" },
  { code: "SOUTH_AMERICA", name: "South America", flag: "🌎" },
  { code: "CENTRAL_AMERICA", name: "Central America & Caribbean", flag: "🌎" },
  { code: "ASIA", name: "Asia", flag: "🌏" },
  { code: "OCEANIA", name: "Oceania", flag: "🌏" },
  { code: "MIDDLE_EAST", name: "Middle East", flag: "🌍" },
  { code: "AFRICA", name: "Africa", flag: "🌍" },
] as const;

export type RegionCode = (typeof REGIONS)[number]["code"];

